import React from 'react';
import YouTube from 'react-youtube';

const TutorialModal = ({ videoId, title }) => {
    const opts = {
        height: '100%',
        width: '100%',
        playerVars: {
            autoplay: 0,
            cc_load_policy: 1
        },
    };

    return (
        <div>
            <h4>{title}</h4>
            <div style={{ paddingBottom: "20px" }}><YouTube videoId={videoId} opts={opts} /></div>

        </div>
    );
};

export default TutorialModal;
